<script lang="ts">
    import LinkList from "../../../widgets/LinkList.svelte"

    export let column: BlockColumn<"text">
</script>

{@html column.text}
{#if column.links?.length}
    <div class="button-wrap gap-m">
        <!-- Buttons sitzen im Wrapper, sollten vermutlich auch flexibel / repeatable sein, mal nur einen, mal zwei, mal keiner -->
        <LinkList links="{column.links}" />
    </div>
{/if}
